import styled from 'styled-components'
export const WorkSection = styled.div `
    padding: 80px 0 100px;
    overflow-x:hidden;
    background-color: #2C1342;
    position: relative
`
export const TransSection = styled.div `
   z-index:800;
     
`

export const Card = styled.div `
   background-color: #26052f; 
`
export const Span = styled.span `
   color: #FA9E19;
   padding: 50px 0;
`
export const Hr = styled.hr `
   width: 60%;
   margin: auto;
   background-color: #FA9E19;
`
export const CardTitle = styled.h5 `
   color: #FA9E19;
  
`
